<template>
  <div class="invoic">
    <el-divider content-position="left">开票记录</el-divider>
    <div class="reset-page-from">
      <span>公司名</span>
      <el-select v-model="searchArr.company" clearable filterable remote @change="search" :size="inputSize"
        placeholder="请输入公司" :remote-method="remoteMethod" :loading="loading">
        <el-option v-for="item in companies" :key="item.id" :label="item.company_name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="invoics" size="mini" border style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column fixed label="序号" type="index"></el-table-column>
      <el-table-column label="公司" fixed width="300">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary">{{ scope.row.company ? scope.row.company.company_name :
        '' }}</el-link>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
              style="margin-left:0.1rem;cursor:pointer"
              @click="copySome(scope.row.company.company_name)"></i></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="购方名称">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" class="count-style"
            @click="handelShowInfo(scope.$index, scope.row)">{{ scope.row.purchaser }}</el-link>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in col" :key="index" :label="item.label" :prop="item.prop" :width="item.width?item.width:120">
        <template slot-scope="scope">
          <div v-if="item.prop === 'created_at'">
            <span class="count_style" style="display: inherit">
              <!-- {{ scope.row[item.prop] === 0 ? "否" : "是" }} -->
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
            </span>
          </div>
          <div v-else-if="item.prop === 'deliver_phone'">
            <phone-com v-if="scope.row.deliver_phone" :comPhone="scope.row.deliver_phone" :vagaryPhone="scope.row.vagary_phone"
              style="display: inline-block" />
          </div>
          <div v-else>
            <span class="count-style">{{ scope.row[item.prop] }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="tr mt-10" layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[5, 10, 20]"
      :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer title="查看发票" :visible.sync="infoDrawer" direction="rtl" :before-close="handleInfoBeforeClose" size="60%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th">发票种类</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td">{{ showData.category }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th">购方名称</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td">{{ showData.purchaser }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th count-style">纳税人识别号</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td">{{ showData.purchaser_tax }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th">地址、电话</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td count-style">{{ showData.purchaser_contact }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th count-style">开户行及帐号</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td count-style">{{ showData.purchaser_bank }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th">发票状态</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td count-style">{{ showData.invoice_status }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th">备注</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td count-style">{{ showData.remark }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row class="col-tab">
              <el-col :span="6">
                <div class="col-th count-style">文件下载地址</div>
              </el-col>
              <el-col :span="18">
                <div class="col-td count-style">-</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-table :data="details" size="mini" border class="mt-10" v-cloak>
          <el-table-column fixed label="序号" type="index"></el-table-column>
          <el-table-column v-for="(item, index) in detailsCol" :key="index" :label="item.label" :prop="item.prop"
            width="120">
          </el-table-column>
        </el-table>
        <div class="text-append">
          <p class="text-append-p">不含税金额：<span class="text-append-span">60 元</span></p>
          <p class="text-append-p">税额：<span class="text-append-span">3.6 元</span></p>
          <p class="text-append-p">含税金额：<span class="text-append-span">63.6 元</span></p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
import PhoneCom from "common/PhoneCom";
export default {
  name: 'Invoicing',
  components: { DateFormatter, PhoneCom },
  data() {
    return {
      searchArr: {
        company: ''
      },
      inputSize: 'mini',
      loading: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10 // 每页显示条数
      },
      companies: [],
      invoics: [],
      showData: {
        'category': '',
        'purchaser': '',
        'purchaser_tax': '',
        'purchaser_contact': '',
        'purchaser_bank': '',
        'invoice_status': '',
        'remark': ''
      },
      details: [],
      col: [
        {
          label: '发票种类',
          prop: 'category'
        },
        {
          label: '开票状态',
          prop: 'invoicing_status'
        },
        {
          label: '购方纳税人识别号',
          prop: 'purchaser_tax'
        },
        {
          label: '购方地址电话',
          prop: 'purchaser_contact'
        },
        {
          label: '交付邮箱',
          prop: 'deliver_email'
        },
        {
          label: '交付手机号',
          prop: 'deliver_phone',
          width: 170
        },
        {
          label: '申请时间',
          prop: 'created_at'
        }
      ],
      detailsCol: [
        {
          label: '商品名称',
          prop: 'name'
        },
        {
          label: '税收分类编码',
          prop: '规格型号'
        },
        {
          label: '规格型号',
          prop: 'model'
        },
        {
          label: '单位',
          prop: 'unit'
        },
        {
          label: '单价(不含税)',
          prop: 'price'
        },
        {
          label: '数量',
          prop: 'num'
        },
        {
          label: '金额(不含税)',
          prop: 'amount'
        },
        {
          label: '税率',
          prop: 'tax_rate'
        },
        {
          label: '税额',
          prop: 'tax'
        }
      ],
      infoDrawer: false
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copySome(data) {
      this.copy(data)
    },
    search() {
      this.billingRecords()
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanies(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanies(query) {
      this.$axios.get('/api/admin/companies?company=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies.data
          }
        })
    },
    billingRecords() {
      this.$axios.get('/api/admin/billingRecords?page=' + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.invoics = data.data.billingRecords.data
            this.pageOption.total = data.data.billingRecords.total
            this.pageOption.currentPage = data.data.billingRecords.current_page
          }
        })
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.billingRecords()
    },
    handelShowInfo(index, row) {
      this.showData.category = row.category
      this.showData.purchaser = row.purchaser
      this.showData.purchaser_tax = row.purchaser_tax
      this.showData.purchaser_contact = row.purchaser_contact
      this.showData.purchaser_bank = row.purchaser_bank
      this.showData.invoice_status = row.invoice_status
      this.showData.remark = row.remark
      this.details = row.details
      this.infoDrawer = true
    },
    clearShow() {
      this.showData.category = ''
      this.showData.purchaser_tax = ''
      this.showData.purchaser_contact = ''
      this.showData.purchaser_bank = ''
      this.showData.invoice_status = ''
      this.showData.remark = ''
      this.details = []
    },
    handleInfoBeforeClose(done) {
      this.clearShow()
      done()
    }
  },
  mounted() {
    this.billingRecords()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.reset-page-from
  display: inline-table
.reset-page-from span
  vertical-align: top
  display: inline-block
  font-size: .24rem
  height: .56rem
  line-height: .52rem
  padding: 0 .24rem
  color: #3a4c61
  border: 1px solid #dbdbdb
  border-right: 0
  box-sizing: border-box
  border-radius: .04rem 0 0 .04rem
  background: rgba(64,158,255,.1)
.invoic >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.invoic
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.search-row .el-col
  margin-bottom: .2rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
.col-tab
  border: .02rem solid #dbdbdb
  border-right: 0
.col-th
  font-size: .24rem
  color: #666
  padding: .24rem .16rem
  background-color: #f5f7fa
  border-right: 1px solid #e4e4e4
.col-td
  font-size: .24rem
  padding: .24rem .16rem
  border-right: .02rem solid #e4e4e4
.text-append
  display: flex
  font-size: .24rem
  height: .64rem
  line-height: .64rem
  border-left: .02rem solid #EBEEF5
  border-right: .02rem solid #EBEEF5
  border-bottom: .02rem solid #EBEEF5
  .text-append-p
    margin-left: .24rem
    margin-right: .24rem
    .text-append-span
      color: #ffaf57
      font-weight: 600
</style>



// WEBPACK FOOTER //
// src/pages/invoicing/Invoicing.vue